import React from "react";
import { Reveal } from "./motion/Reveal";
import { MessageCircle } from "lucide-react";
import { STRIPE_LINKS, WHATSAPP_URL, trackAndOpen } from "../constants/links";

export default function Pricing() {
    return (
        <section id="precios" className="relative py-20 sm:py-28 bg-alma-ivory overflow-hidden">
            <div className="max-w-[1000px] mx-auto px-6 sm:px-8">
                <Reveal>
                    <div className="text-center max-w-2xl mx-auto mb-12">
                        <span className="text-xs tracking-[0.35em] uppercase text-alma-goldDeep font-medium">
                            Elige tu modalidad
                        </span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] text-alma-ink">
                            Entra tal como eres,
                            <span className="italic text-alma-goldDeep"> hoy.</span>
                        </h2>
                    </div>
                </Reveal>

                <div className="grid md:grid-cols-2 gap-6">
                    <Reveal>
                        <div className="h-full bg-alma-white rounded-[1.75rem] border border-alma-mist p-9 flex flex-col text-center">
                            <span className="text-[10px] tracking-[0.3em] uppercase text-alma-slate/70">Modalidad mensual</span>
                            <div className="mt-4 font-serif text-6xl text-alma-ink">27&nbsp;€<span className="text-2xl text-alma-slate"> /mes</span></div>
                            <p className="mt-4 text-[15px] text-alma-slate leading-relaxed flex-1">
                                Sin permanencia. Puedes quedarte durante el tiempo que te resuene.
                            </p>
                            <button
                                onClick={() => trackAndOpen(STRIPE_LINKS.monthly, "InitiateCheckout", { content_name: "monthly", value: 27, currency: "EUR" })}
                                data-testid="pricing-monthly-btn"
                                className="mt-8 rounded-full bg-gradient-to-r from-alma-gold to-alma-goldDeep text-alma-ink hover:brightness-105 h-13 py-4 font-semibold transition"
                            >
                                Quiero entrar
                            </button>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="h-full relative bg-alma-ink text-alma-white rounded-[1.75rem] p-9 flex flex-col text-center overflow-hidden">
                            <div className="absolute top-0 right-0 h-36 w-36 bg-alma-gold/20 blur-3xl" aria-hidden />
                            <span className="relative text-[10px] tracking-[0.3em] uppercase text-alma-goldSoft/80">Modalidad anual</span>
                            <div className="relative mt-4 font-serif text-6xl">277&nbsp;€</div>
                            <p className="relative mt-4 text-[15px] text-alma-white/75 leading-relaxed flex-1">
                                Doce meses dentro de Alquimia del Alma y un ahorro de 47 €.
                            </p>
                            <button
                                onClick={() => trackAndOpen(STRIPE_LINKS.annual, "InitiateCheckout", { content_name: "annual", value: 277, currency: "EUR" })}
                                data-testid="pricing-annual-btn"
                                className="relative mt-8 rounded-full bg-alma-white text-alma-ink hover:bg-alma-goldSoft h-13 py-4 font-semibold transition"
                            >
                                Quiero entrar todo el año
                            </button>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-10 text-center">
                        <p className="text-sm text-alma-slate mb-4">
                            Después del pago, escríbenos por WhatsApp para solicitar tu acceso.
                        </p>
                        <button
                            onClick={() => trackAndOpen(WHATSAPP_URL, "Contact", { content_name: "whatsapp_access" })}
                            data-testid="whatsapp-access-btn"
                            className="group inline-flex items-center gap-2.5 rounded-full border border-alma-ink text-alma-ink hover:bg-alma-ink hover:text-alma-white h-12 px-7 text-sm font-semibold transition-colors"
                        >
                            <MessageCircle className="h-4 w-4" strokeWidth={2} />
                            Ya he realizado el pago
                        </button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
